import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import loader from '../../assets/Images/loader.gif';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import micon from "../../assets/Images/schedule.png";
 
const ContactManagement = () => {
  // Contact data states
  const [contactDataAll, setContactDataAll] = useState([]);
  const [contactDataOpen, setContactDataOpen] = useState([]);
  const [contactDataClose, setContactDataClose] = useState([]);
  const [contactDataAssigned, setContactDataAssigned] = useState([]);
 
  // Search inputs & filters
  const [searchInputAll, setSearchInputAll] = useState('');
  const [searchInputOpen, setSearchInputOpen] = useState('');
  const [searchInputClose, setSearchInputClose] = useState('');
  const [searchInputAssigned, setSearchInputAssigned] = useState('');
 
  const [searchFilterAll, setSearchFilterAll] = useState([]);
  const [searchFilterOpen, setSearchFilterOpen] = useState([]);
  const [searchFilterClose, setSearchFilterClose] = useState([]);
  const [searchFilterAssigned, setSearchFilterAssigned] = useState([]);
 
  const [flagAll, setFlagAll] = useState(false);
  const [flagOpen, setFlagOpen] = useState(false);
  const [flagClose, setFlagClose] = useState(false);
  const [flagAssigned, setFlagAssigned] = useState(false);
 
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  
   const PrimaryEmail = sessionStorage.getItem('PrimaryEmail')

  const businessEmails = [
    // "salesperson1@spectra.co",
    "manager1@spectra.co",
    "raghunath.n@spectra.co",
    "mahadeva.s@spectra.co",
    "sadiq.ali@spectra.co",
    "gangadhara.ms@spectra.co",
    "harish.kl@spectra.co",
    "thumma.reddy@spectra.co",
    "bharath.kumar@spectra.co",
    "santhosh.nr@spectra.co",
  ];
 
  // Helper to fetch contacts by status
  const fetchData = async (status, setter) => {
    try {
      setLoading(true);
      const currentDate = new Date();
      const toDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
      const fromDateObj = new Date(currentDate);
      fromDateObj.setMonth(currentDate.getMonth() - 2);
      const formattedFromDate = `${fromDateObj.getFullYear()}-${String(fromDateObj.getMonth() + 1).padStart(2, '0')}-${String(fromDateObj.getDate()).padStart(2, '0')}`;
 
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: 'getAllContact',
        Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
        businessSegment: 'Business',
        fromDate: formattedFromDate,
        industrySegment: "",
        productSegment: "",
        password: sessionStorage.getItem('password'),
        searchBoxValue: '',
        status,
        toDate,
        userName: sessionStorage.getItem('userName'),
      };
 
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData),
      });
      if (response.ok) {
        const result = await response.json();
        if (result?.Response?.Data) setter(result.Response.Data);
      } else {
        toast.warning(response.status, { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
      }
    } catch (error) {
      toast.warning(error, { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
    } finally {
      setLoading(false);
    }
  };
 
  // Initial fetch for All/Open/Close
  useEffect(() => {
    fetchData('All', setContactDataAll);
    fetchData('Open', setContactDataOpen);
    fetchData('Disqualified', setContactDataClose);
  }, []);
 
  // Derive Assigned from All or search results
  const deriveAssigned = (data) => data.filter(c =>
    c.OwnerName != null &&
    c.OwnerName !== c.CreatedBy);
  useEffect(() => {
    setContactDataAssigned(deriveAssigned(contactDataAll));
  }, [contactDataAll]);
 
  // Search handlers
  const handleSearch = async (searchInput, status, setFilter, setFlag, deriveFn) => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: 'getAllContact',
        Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
        businessSegment: 'Business',
        fromDate: '',
        industrySegment: '',
        productSegment: '',
        password: sessionStorage.getItem('password'),
        searchBoxValue: searchInput,
        status,
        toDate: '',
        userName: sessionStorage.getItem('userName'),
      };
      const response = await fetch(apiUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(requestData)
      });
      const result = await response.json();
      if (result?.Response?.Data) {
        let data = result.Response.Data;
        if (deriveFn) data = deriveFn(data);
        setFilter(data);
        setFlag(true);
      }
    } catch (error) {
      toast.warning(error, { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
    } finally {
      setLoading(false);
    }
  };
 
  const handleSearchAll = () => handleSearch(searchInputAll, 'not equal closed', setSearchFilterAll, setFlagAll);
  const handleSearchOpen = () => handleSearch(searchInputOpen, 'Open', setSearchFilterOpen, setFlagOpen);
  // const handleSearchClose = () => handleSearch(searchInputClose, 'Close', setSearchFilterClose, setFlagClose);
  const handleSearchClose = () => handleSearch(searchInputClose, 'Disqualified', setSearchFilterClose, setFlagClose);
  const handleSearchAssigned = () => handleSearch(searchInputAssigned, 'All', setSearchFilterAssigned, setFlagAssigned, deriveAssigned);
 
  // Navigation & actions
  const handleBellClick = (e, ContactId) => { e.stopPropagation(); navigate(`/businessMeetings?ContactId=${ContactId}`); };
  
  const updateForm = (ContactId) => {
    // if (businessEmails.includes(PrimaryEmail)) {
    //   navigate(`/businessPgContactForm?ContactId=${ContactId}`);
    // } else {
      navigate(`/contactsManagementForm?ContactId=${ContactId}`);
    // }
  }
  const redirectDashboardPage = () => navigate('/business');

  const redirectContactsForm = () => {
    // if (businessEmails.includes(PrimaryEmail)) {
    //   navigate("/businessPgContactForm");
    // } else {
      navigate("/contactsManagementForm");
    // }
  };
 
  // Components
  const LoadingSpinner = () => (
    <div className="loader-wrapper"><div className="loader"><img src={loader} alt='loading' /></div></div>
  );
 
  const renderTabContent = (data, flag, filterData, searchInput, setSearchInput, handleSearch) => (
    <>
      <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
        <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
          <span>
            <input
              type="text"
              className='search-box p-1 border-0'
              placeholder="Search"
              style={{ width: '250px' }}
              value={searchInput}
              onChange={e => setSearchInput(e.target.value)}
            />
            <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
          </span>&nbsp;&nbsp;
          <button className='btn-sm border-0 bg-light' style={{marginLeft: "10px"}} onClick={handleSearch}>Search</button>
        </div>
      </div>
      {loading ? <LoadingSpinner /> : renderCards(flag ? filterData : data)}
    </>
  );
 
  const renderCards = dataArray => (
    <div className='container-fluid'>
      <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
        {dataArray.map((contact, idx) => (
          <div className="col" key={idx} onClick={() => updateForm(contact.ContactId)}>
            <div className="card mb-3">
              <div className="m-2 card-data" style={{ display: "inline-flex" }}>
                <div>
                  <p className="contact-card-title">{contact.FullName} ({contact.ContactId})</p>
                  <p className="contact-card-title">{contact.PGName}</p>
                  <p className="contact-card-text">Mobile No : {contact.MobileNumber}</p>
                  <p className="contact-card-text">Email ID : {contact.EmailAddress}</p>
                  <p className="contact-card-text">Status : {contact.Status}</p>
                  <p className="contact-card-text">Created on : {contact.CreatedOn}</p>
                  <p className="contact-card-text">Created By : {contact.CreatedBy}</p>
                </div>
                <div style={{ position: "absolute", top: "50%", right: 0, transform: "translateY(-50%)" }}>
                  <div onClick={e => handleBellClick(e, contact.ContactId)} style={{ position: "relative", cursor: "pointer", width: 30, height: 30 }}>
                    <img src={micon} alt="Schedule Icon" style={{ width: 30, height: 30 }} />
                    {contact.MeetingCounter > 0 && (
                      <span style={{ position: "absolute", top: -5, right: -5, backgroundColor: contact.MeetingStatus == "0" ? "red" : "green", color: "white", borderRadius: "50%", width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: "bold" }}>
                        {contact.MeetingCounter}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
 
  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span style={{ cursor: "pointer" }} onClick={redirectDashboardPage}><i className="fa-solid fa-arrow-left-long" /></span>
          <span className="p-1 m-3">Business Contacts</span>
        </div>
        <div className="container-fluid">
          <ul className="nav nav-tabs">
            <li className="nav-item"><a className="nav-link active" data-bs-toggle="tab" href="#all">All</a></li>
            <li className="nav-item"><a className="nav-link" data-bs-toggle="tab" href="#open">Open</a></li>
            <li className="nav-item"><a className="nav-link" data-bs-toggle="tab" href="#closed">Closed</a></li>
            <li className="nav-item"><a className="nav-link" data-bs-toggle="tab" href="#assigned">Assigned</a></li>
          </ul>
        </div>
      </div>
      <div className="tab-content tab-main-content">
        <div className="tab-pane fade show active" id="all">
          {renderTabContent(contactDataAll, flagAll, searchFilterAll, searchInputAll, setSearchInputAll, handleSearchAll)}
        </div>
        <div className="tab-pane fade" id="open">
          {renderTabContent(contactDataOpen, flagOpen, searchFilterOpen, searchInputOpen, setSearchInputOpen, handleSearchOpen)}
        </div>
        <div className="tab-pane fade" id="closed">
          {renderTabContent(contactDataClose, flagClose, searchFilterClose, searchInputClose, setSearchInputClose, handleSearchClose)}
        </div>
        <div className="tab-pane fade" id="assigned">
          {renderTabContent(contactDataAssigned, flagAssigned, searchFilterAssigned, searchInputAssigned, setSearchInputAssigned, handleSearchAssigned)}
        </div>
      </div>
      <div className='position-fixed bottom-0 end-0 m-4' onClick={redirectContactsForm}>
        <span className='bg-dark rounded-circle faPlus-icon'><i className="fa-solid fa-plus fa-lg text-light m-1" /></span>
      </div>
    </>
  );
};
 
export default ContactManagement;
 